import { useState } from "react";
import { Upload, Loader2 } from "lucide-react";
import { toast } from "sonner";
import api, { formatApiError } from "@/lib/api";

export default function ImageUpload({ value, onChange, testid }) {
  const [uploading, setUploading] = useState(false);

  const handleFile = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    const fd = new FormData();
    fd.append("file", file);
    setUploading(true);
    try {
      const { data } = await api.post("/admin/upload", fd, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      onChange(data.url);
      toast.success("Image uploaded");
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setUploading(false);
      e.target.value = "";
    }
  };

  return (
    <div>
      {value ? (
        <img src={value} alt="preview" data-testid={`${testid}-preview`} className="mb-2 h-32 w-full border border-white/10 bg-black object-contain" />
      ) : null}
      <div className="flex gap-2">
        <input
          data-testid={testid}
          value={value || ""}
          onChange={(e) => onChange(e.target.value)}
          placeholder="Image URL or upload →"
          className="w-full border border-white/15 bg-black/40 px-4 py-3 text-sm text-white outline-none transition-colors focus:border-[#D4AF37]"
        />
        <label
          data-testid={`${testid}-upload-button`}
          className="flex cursor-pointer items-center gap-2 border border-[#D4AF37]/50 px-4 text-[#D4AF37] transition-colors hover:bg-[#D4AF37] hover:text-black"
        >
          {uploading ? <Loader2 className="h-4 w-4 animate-spin" strokeWidth={1.5} /> : <Upload className="h-4 w-4" strokeWidth={1.5} />}
          <input type="file" accept="image/*" className="hidden" onChange={handleFile} />
        </label>
      </div>
    </div>
  );
}
